import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class FirGiltiConsolidatedGridService {

  constructor(private http: HttpClient) {}

  saveManualData(
    baseUrl: string,
    rowData: any,
    colId: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=wutjlp`;

    const jsonObj = [{
      tax_year: rowData.TAX_YEAR,
      ho_leid: rowData.HO_LEID,
      ho_cdr_no: rowData.HO_CDR_NO,
      filing_group: rowData.FILING_GROUP,
      scenario: rowData.SCENARIO,
      col_type: colId,
      col_value: rowData[colId],
      shareholder_leid: rowData.SHAREHOLDER_LEID,
      ho_combination_key: rowData.HO_COMBINATION_KEY,
      shareholder_cdr_no: rowData.SHAREHOLDER_CDR_NO,
      functional_curr: rowData.FUNCTIONAL_CURRENCY
    }];

    const jsonSettings = [{
      sso_id: globalService?.globalParams?.sso_id || '',
      screen_key: globalService?.globalParams?.screen_key || ''
    }];

    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ jsonObj: JSON.stringify(jsonObj) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(jsonSettings) }, params);
    params.object_id = rowData.object_id;
    params.sso_id = globalService?.globalParams?.sso_id || '';
    params.process_name = 'saveManualData';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
